export default "__VITE_ASSET__0be08cb6__"